import { createFeature, createReducer, on } from '@ngrx/store';

import { LayoutActions } from './layout.actions';

export const layoutFeatureKey = 'layout';

export interface LayoutState {
  isMobile: boolean;
  isSidebarOpened: boolean;
  isRightPanelOpened: boolean;
  isRightPanelMaximized: boolean;
}

const initialLayoutState: LayoutState = {
  isMobile: false,
  isSidebarOpened: true,
  isRightPanelOpened: false,
  isRightPanelMaximized: false,
};

export const layoutFeature = createFeature({
  name: layoutFeatureKey,
  reducer: createReducer(
    initialLayoutState,
    on(LayoutActions.setIsMobile, (state, { isMobile }) => ({
      ...state,
      isMobile,
    })),
    on(LayoutActions.setSidebarOpened, (state, { isOpened }) => ({
      ...state,
      isSidebarOpened: isOpened,
    })),
    on(LayoutActions.setRightPanelOpened, (state, { isOpened }) => ({
      ...state,
      isRightPanelOpened: isOpened,
      isRightPanelMaximized: isOpened ? state.isRightPanelMaximized : false, // reset the maximized state when the panel is closed
    })),
    on(LayoutActions.setRightPanelMaximized, (state, { isMaximized }) => ({
      ...state,
      isRightPanelMaximized: isMaximized,
    })),
    on(LayoutActions.clearLayoutState, () => initialLayoutState),
  ),
});
